/**
 * tccf7Load クラス
 * - ステップに応じた body クラスの追加
 * - Enter キーでのフォーム送信を制御
 */
export default class tccf7Load {
  /**
   * @param {HTMLElement} form - 対象となるフォームラッパー要素
   */
  constructor(form) {
    this.form = form;
    this.boundEnterCancel = this.enterCancelHandler.bind(this); // イベント解除のためにバインド
    this.init();
  }

  /**
   * 初期処理
   */
  init() {
    this.setEnterCancel();
  }

  /**
   * body にステップ状態のクラスを追加
   * @param {string} step - 'step-input', 'step-confirm' など
   */
  setStep(step) {
    document.body.classList.add(step);
  }

  /**
   * Enter キーによる誤送信を防止するイベントを登録
   * （textarea は除外）
   */
  setEnterCancel() {
    this.form.addEventListener('keydown', this.boundEnterCancel);
  }

  /**
   * イベントリスナー関数（Enter キー抑止）
   * @param {KeyboardEvent} event 
   */
  enterCancelHandler(event) {
    if (event.key === 'Enter') {
      const target = event.target;

      if (target.tagName === 'TEXTAREA') return;

      if (target.closest('.wpcf7-form')) {
        event.preventDefault();
        return false;
      }
    }
  }

  /**
   * イベントリスナーの解除（必要に応じて使用）
   */
  destroy() {
    this.form.removeEventListener('keydown', this.boundEnterCancel);
  }
}
